<template>
  <div>
    <a
        href="javascript:;"
        data-toggle="modal"
        data-target="#warning-modal-preview"
        style="display: none"
        id="show-modal-warn"
        class="button inline-block bg-theme-1 text-white"
    >Show Modal</a
    >
    <div id="warning-modal-preview" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-12 mx-auto mt-3" />
          <div class="text-3xl mt-5">Oops...</div>
          <div class="text-gray-600 mt-2">{{modalText}}</div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
              type="button"
              data-dismiss="modal"
              class="button w-24 bg-theme-1 text-white"
          >
            Ok
          </button>
        </div>
        <div
            class="p-5 text-center border-t border-gray-200 dark:border-dark-5"
        >
        </div>
      </div>
    </div>
    <div class="flex items-center mt-8">
    </div>
    <!-- BEGIN: Wizard Layout -->
<!--    <div v-if="isValid" class="intro-y box py-10 sm:py-20 mt-5">-->
<!--      <div class="px-5 mt-10">-->
<!--        <div class="font-medium text-center text-lg">Change your password</div>-->
<!--&lt;!&ndash;        <div class="text-gray-600 text-center mt-2">&ndash;&gt;-->
<!--&lt;!&ndash;          To start off, please enter your username, email address and password.&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--      </div>-->
<!--      <div-->
<!--          class="px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200 dark:border-dark-5"-->
<!--      >-->
<!--        <div class="grid grid-cols-12 gap-4 row-gap-5 mt-5">-->
<!--          <div class="intro-y col-span-12 sm:col-span-6">-->
<!--            <div class="mb-2">New password</div>-->
<!--            <input-->
<!--                v-model="newPassword"-->
<!--                type="password"-->
<!--                class="input w-full border flex-1"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="intro-y col-span-12 sm:col-span-6">-->
<!--            <div class="mb-2">Confirm password</div>-->
<!--            <input-->
<!--                v-model="confirmPassword"-->
<!--                type="password"-->
<!--                class="input w-full border flex-1"-->
<!--            />-->
<!--            <br/>-->
<!--            <br/>-->
<!--            <div-->
<!--                v-if="infoError === true "-->
<!--                class="rounded-md flex items-center px-5 py-4 mb-2 bg-theme-6 text-white"-->
<!--            >-->
<!--              <AlertOctagonIcon class="w-6 h-6 mr-2" />-->
<!--              Confirm password not matched-->
<!--            </div>-->
<!--          </div>-->
<!--          <div-->
<!--              class="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5"-->
<!--          >-->
<!--            <button-->
<!--                class="button w-24 justify-center block bg-theme-1 text-white ml-2"-->
<!--                :disabled="newPassword !== confirmPassword"-->
<!--                @click="handleSubmit"-->
<!--            >-->
<!--              Next-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div v-if="isSent" class="intro-y box py-10 sm:py-20 mt-5">
      <div class="px-5 mt-10">
        <div class="font-medium text-center text-lg">Success. Check your email.</div>
        <!--        <div class="text-gray-600 text-center mt-2">-->
        <!--          To start off, please enter your username, email address and password.-->
        <!--        </div>-->
      </div>
    </div>

    <div v-else class="intro-y box py-10 sm:py-20 mt-5">
      <div class="px-5 mt-10">
        <div class="font-medium text-center text-lg">Type your email and we will send instructions for reset your password</div>
        <!--        <div class="text-gray-600 text-center mt-2">-->
        <!--          To start off, please enter your username, email address and password.-->
        <!--        </div>-->
      </div>
      <div class="text-center">
        <div class="intro-y col-span-12 sm:col-span-6">
          <br />
          <input
              v-model="email"
              type="text"
              class="input border flex-1"
              placeholder="example@mail.com"
          />
        </div>

        <br />
        <br />
        <div v-if="!loading">
          <button
              type="button"
              class="button inline-block bg-theme-1 text-white"
              @click="handleSubmit"
          >
            Submit
          </button>
        </div>
        <br />
        <div v-if="loading">
          <button
              class="button w-24 inline-block mr-1 mb-2 bg-theme-1 text-white inline-flex items-center"
          >
            Loading
            <LoadingIcon
                icon="oval"
                color="white"
                class="w-4 h-4 ml-auto"
            />
          </button>
        </div>
      </div>
    </div>
    <br />
    <!-- END: Wizard Layout -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      config: {
        headers: {
          Authorization: "false",
        }
      },
      infoError: false,
      modalText: "",
      email: null,
      isSent: false,
      loading: false
    }
  },
  methods: {
    handleSubmit(e) {
      let self = this
      self.loading = true
      console.log("submit")
      e.preventDefault();
      axios
          .post("reset-password/", {
            email: self.email
          }, self.config)
          .then(response => {
            if (response.data.status === "OK") {
              self.isSent = true
              // this.$router.push("/login")
            } else {
              self.modalText = "Err. There is no active user associated with this e-mail address"
              document.getElementById("show-modal-warn").click()
            }

            self.loading = false

          })
          .catch(function(error) {
            self.modalText = "Err. There is no active user associated with this e-mail address"
            document.getElementById("show-modal-warn").click()
            console.error(error.response);
            console.error("error.response");
            self.loading = false
            // self.infoError = true
          });
    }
  }
};
</script>
